import React from 'react';

// Helper to wrap emojis in sticker-outline spans
const stickerizeEmojisInText = (text: string) => {
    if (!text) return text;
    // Split by emoji character sequences
    const emojiRegex = /(\p{Extended_Pictographic}\uFE0F?[\u{1F3FB}-\u{1F3FF}]?(?:\u200D\p{Extended_Pictographic}\uFE0F?[\u{1F3FB}-\u{1F3FF}]?)*)/gu;
    const parts = text.split(emojiRegex);
    return parts.map((part, i) => {
        if (i % 2 === 1) {
            return (
                <span key={i} className="sticker-outline inline-block" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
                    {part}
                </span>
            );
        }
        return part;
    });
};

export const LinkifyText = ({ text, style }: { text: string; style?: React.CSSProperties }) => {
    if (!text) return null;
    const combinedRegex = /(https?:\/\/[^\s]+|www\.[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}[^\s]*|[a-zA-Z0-9.-]+\.(?:com|net|org|edu|gov|io|me|app|co|ai|xyz|ca|uk|fr|de|jp|it|br|ru|es|in|cn|tv)(?:\/[^\s]*)?|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/gi;
    const parts = text.split(combinedRegex);
    
    const content = (
        <>
            {parts.map((part, i) => {
                // Odd indices from split with capture groups are always the matched tokens
                if (i % 2 === 1) {
                    const isEmail = part.includes('@') && !part.startsWith('http');
                    let href = part;
                    if (isEmail) {
                        href = `mailto:${part}`;
                    } else if (!part.startsWith('http')) {
                        href = `https://${part}`;
                    }
                    return (
                        <a href={href} key={i} target={isEmail ? undefined : "_blank"} rel="noopener noreferrer" className="text-blue-400 hover:underline break-all">
                            {stickerizeEmojisInText(part)}
                        </a>
                    );
                }
                return <React.Fragment key={i}>{stickerizeEmojisInText(part)}</React.Fragment>;
            })}
        </>
    );

    return style ? <span style={style}>{content}</span> : content;
};
